import { useEffect } from "react";
import { logVisit, logEvent } from "../utils/eventTracker";

export default function useVisitTracking() {
  useEffect(() => {
    if (sessionStorage.getItem("visitSent")) return;

    // 🕵️‍♂️ Capture GCLID from URL
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");

    if (gclid) {
      sessionStorage.setItem("gclid", gclid);
    }

    sessionStorage.setItem("visitSent", "pending");

    const trackVisit = async () => {
      try {
        const geoRes = await fetch("https://ipapi.co/json/");
        const geo = await geoRes.json();

        const payload = {
          ip_address: geo.ip,
          user_agent: navigator.userAgent,
          location: `${geo.city}, ${geo.country_name}`,
          coordinates: `${geo.latitude},${geo.longitude}`,
          referrer: document.referrer || null,
          gclid: sessionStorage.getItem("gclid") || null, // 👈 send GCLID
        };

        sessionStorage.setItem("visitCity", geo.city || "");
        sessionStorage.setItem("visitCountry", geo.country_name || "");
        sessionStorage.setItem("visitCountryCode", geo.country_code || "");

        const visit_id = await logVisit(payload);

        if (visit_id) {
          sessionStorage.setItem("visitId", visit_id);
          sessionStorage.setItem("visitSent", "true");
        } else {
          sessionStorage.removeItem("visitSent");
        }
      } catch (err) {
        console.error("❌ Visit tracking failed:", err);
        sessionStorage.removeItem("visitSent");
      }
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(() => trackVisit(), { timeout: 3000 });
    } else {
      setTimeout(() => trackVisit(), 2000);
    }

    const handleUnload = () => {
      const visit_id = sessionStorage.getItem("visitId");
      if (!visit_id) return;
      logEvent("exit", { reason: "unload" });
    };

    window.addEventListener("beforeunload", handleUnload);
    return () => window.removeEventListener("beforeunload", handleUnload);
  }, []);
}
